<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title">รายละเอียด{{ getProgramType() }}</h5>
    </template>
    <template v-slot:section-body>
      <form>
        <div class="row">
          <div class="col-md-8">
            <FormGroup :errorMessage="getErrorMessage('schedule')">
              <h5 class="name">เวลาออกอากาศ</h5>
              <input
                type="text"
                placeholder="เวลาออกอากาศ"
                class="form-control"
                :class="{'is-invalid': getErrorMessage('schedule')}"
                :value="currentProgram.schedule"
                @input="$store.dispatch('setCurrentProgram', { schedule: $event.target.value })" />
              <div
                class="invalid-feedback"
                v-if="getErrorMessage('schedule')">
                {{getErrorMessage('schedule')}}
              </div>
            </FormGroup>
            <FormGroup :errorMessage="getErrorMessage('duration')">
              <h5 class="name">ความยาว</h5>
              <input
                type="text"
                placeholder="ความยาว"
                class="form-control"
                :class="{'is-invalid': getErrorMessage('duration')}"
                :value="currentProgram.duration"
                @input="$store.dispatch('setCurrentProgram', { duration: $event.target.value })"/>
              <div
                class="invalid-feedback"
                v-if="getErrorMessage('duration')">
                {{getErrorMessage('duration')}}
              </div>
            </FormGroup>
            <FormGroup
              class="with-help-text"
              :errorMessage="getErrorMessage('tagline')">
              <h5 class="name">รายละเอียดอย่างสั้น</h5>
              <small class="help-text">
                คำอธิบายสั้นๆ ที่จะถูกใช้ในการแสดงตัวอย่างใน เสิร์ชเอ็นจิ้นและโซเชียลเน็ทเวิร์ค
              </small>
              <textarea
                type="text"
                rows="5"
                class="form-control"
                :class="{'is-invalid': getErrorMessage('tagline')}"
                placeholder="รายละเอียดอย่างสั้น"
                :value="currentProgram.tagline"
                @input="$store.dispatch('setCurrentProgram', { tagline: $event.target.value })" />
            </FormGroup>
            <FormGroup>
              <h5 class="name">คำอธิบาย</h5>
              <HtmlEditor
                :description="currentProgram.description"
                @update:description="(description) => $store.dispatch('setCurrentProgram', { description })" />
            </FormGroup>
            <FormGroup>
              <h5 class="name">พันธกิจ</h5>
              <HtmlEditor
                :description="currentProgram.additionalDescription"
                @update:description="(description) => $store.dispatch('setCurrentProgram', { additionalDescription: description})" />
            </FormGroup>
          </div>
          <div class="col-md-4">
            <div class="form-group-container">
              <div class="form-group-item">
                <ManageProgramFeatures
                  :features="currentProgram.features"
                  @update:features="(features) => $store.dispatch('setCurrentProgram', { features })" />
              </div>
              <!-- คุณสมบัติของรายการ -->
              <div class="form-group-item">
                <ManageProgramBroadcasting
                  :broadcastingChannels="currentProgram.broadcastingChannels"
                  @update:broadcastingChannels="(broadcastingChannels) => $store.dispatch('setCurrentProgram', { broadcastingChannels })"/>
              </div>
            </div>
            <ManageCollectionItem
              v-if="!isProgramCreate()"
              :itemId="currentProgram.id"
              :collectionType="'program'">
              เพิ่มรายการลงชุดรายการ
            </ManageCollectionItem>
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { loadTaxonomyByKey } from '@/taxonomy/api';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';
import HtmlEditor from '@/htmlEditor/HtmlEditor.vue';
import ManageCollectionItem from '@/collection/ManageCollectionItem.vue';
import ManageProgramFeatures from './ManageProgramFeatures.vue';
import ManageProgramBroadcasting from './ManageProgramBroadcasting.vue';


export default {
  components: {
    HtmlEditor,
    FormGroup,
    Section,
    ManageProgramFeatures,
    ManageProgramBroadcasting,
    ManageCollectionItem,
  },
  data() {
    return {
      tags: [],
      contentCategories: null,
      features: {},
    };
  },
  created() {
    this.loadContentCategories();
    this.loadTags();
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
      saveProgramState: (state) => state.programItem.saveProgramState,
    }),
  },
  methods: {
    async loadContentCategories() {
      const response = await loadTaxonomyByKey('content-category');
      this.contentCategories = response.data.data;
    },
    async loadTags() {
      const response = await loadTaxonomyByKey('tag');
      this.tags = response.data.data;
    },
    isProgramCreate() {
      const createProgram = this.$route.path;
      if (createProgram.includes('create')) {
        return true;
      }
      return false;
    },
    onChangeStatus(newStatus) {
      this.$store.dispatch('setCurrentProgram', {
        status: newStatus.status,
        startPublish: newStatus.startPublish,
        endPublish: newStatus.endPublish,
      });
    },
    getErrorMessage(fieldName) {
      return _.get(this.saveProgramState.error, `${fieldName}`, null);
    },
    onUpdateFeatures(features) {
      this.$store.dispatch('setCurrentProgram', { features });
    },
    getProgramType() {
      if (this.currentProgram.programType === 'program') {
        return 'รายการ';
      }
      return 'ซีซั่น';
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.form-group-container {
  .form-group-item {
    margin-bottom: $spacer;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

-status-container {
  margin-left: auto;
  display: flex;
  align-items: center;
}

</style>
